export enum KindFeatures {
  "ADD_WORKFLOW" = "add_workflow",
  "VIEW_REPORTS" = "view_reports"
}

export enum ComponentKey {
  "PROCESS" = "process",
  "SWIMLANES" = "swimlanes",
  "STEPS" = "steps",
  "FIELDS" = "fields",
  "RULES" = "rules",
  "CONDITIONS" = "conditions",
  "CONDITION_GROUPS" = "conditionGroups",
  "BULK_ACTIONS" = "bulkActions",
  "EVENT_RULES" = "eventRules",
  "STATE_RULES" = "stateRules"
}

export const componentKeyToLabelMap = {
  [ComponentKey.PROCESS]: "Process",
  [ComponentKey.SWIMLANES]: "Swimlane",
  [ComponentKey.STEPS]: "Step",
  [ComponentKey.FIELDS]: "Field",
  [ComponentKey.RULES]: "Rule",
  [ComponentKey.CONDITIONS]: "Condition",
  [ComponentKey.CONDITION_GROUPS]: "Condition Group",
  [ComponentKey.BULK_ACTIONS]: "Bulk Action",
  [ComponentKey.EVENT_RULES]: "Event Rule",
  [ComponentKey.STATE_RULES]: "State Rule"
};

export enum SpecialKey {
  "ROOT" = "__root__" // ONLY used for proxy and change detection
}
